import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { Axios } from '@utils/api/axios-instance.ts';
import { useAppSearchParams } from '@utils/hooks/use-app-search-params.ts';
import { getEncodedFilters } from '@utils/extensions/filter.extension.ts';

export const useDeleteResellerPublication = (planId: number) => {
  const queryClient = useQueryClient();
  const { searchParams, filters } = useAppSearchParams();
  const offset = parseInt(searchParams.offset || '0');
  const limit = parseInt(searchParams.limit || '10');
  const filtersString = getEncodedFilters(filters);

  const deleteResellerPublication = async (publicationId: number) => {
    const response = await Axios.delete(
      `${DELETE_URL(planId.toString(), publicationId.toString()).resellerPublication}`
    );
    return response.data;
  };

  return useMutation<void, AxiosError<BaseError>, number>(
    (publicationId: number) => deleteResellerPublication(publicationId),
    {
      onSuccess: () => {
        // Note: toast removed from here
        queryClient.invalidateQueries([
          'publication',
          offset,
          limit,
          filtersString
        ]);
      },
      useErrorBoundary: false
    }
  );
};
